<template>
  <div
    class="bigdata_container"
    id="bigdata"
    v-loading="isLoading"
    element-loading-text="拼命加载中..."
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div id="container" class="mymap" style="width: 100%; height: 100%"></div>
    <!-- <div class="header"></div> -->
    <div class="customerTop">
      <img src="../assets/img/top.png" alt="" srcset="" />
      <div class="titleFirst"></div>
      <div class="titleSecond"></div>
      <h1>{{ this.$store.state.info.orgName }}智慧养老可视化</h1>
    </div>
    <div class="quanp">
      <el-button id="fullScreen" @click="showFullScreen" type="primary"
        >{{ onFullScreen ? "退出全屏" : "进入全屏" }}
      </el-button>
    </div>
    <transition name="nameoftransition">
      <div class="info_tisp" v-show="infoTisp">
        <i class="el-message__icon el-icon-info"></i>未搜索到相关数据
      </div>
    </transition>
    <div class="main_left">
      <!-- 服务概况 -->
      <div class="left_top left">
        <div class="headerBox">服务概况</div>
        <div class="iconBox">
          <div class="box" @click="initMarker">
            <div class="img" style="cursor: pointer">
              <img src="../assets/img/a1.png" alt="" />
            </div>
            <div class="txt">
              <!-- @click='initMarker' -->
              老人走访数量<br />
              <span style="color: #ce040e">{{ this.state.oldPersons }}</span>
            </div>
          </div>
          <div class="box" @click="getServation">
            <div class="img" style="cursor: pointer">
              <img src="../assets/img/a2.png" alt="" />
            </div>
            <div class="txt">
              <!-- -->
              机构数量<br />
              <span style="color: #d06209">{{ this.state.departments }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="left_center left">
        <div class="headerBox">分类统计</div>
        <div class="typeClick">
          <span
            style="cursor: pointer"
            :class="{ active: clickIndex == 1 }"
            @click="changeClick(1)"
            >年龄</span
          >
          <span
            style="cursor: pointer"
            :class="{ active: clickIndex == 2 }"
            @click="changeClick(2)"
            >性别</span
          >
        </div>
        <div class="type">
          <div
            id="typeEcharts"
            ref="typeEcharts"
            style="width: 100%; height: 100%"
          ></div>
        </div>
      </div>
      <div class="left_bottom left">
        <div class="headerBox">服务类别统计</div>
        <div class="type">
          <div
            id="servicesEcharts"
            ref="servicesEcharts"
            style="width: 100%; height: 100%"
          ></div>
        </div>
      </div>
    </div>
    <div class="main_right">
      <div class="right_top right">
        <div class="headerBox">老人类别统计</div>
        <div class="type">
          <div
            id="olderEcharts"
            ref="olderEcharts"
            style="width: 100%; height: 100%"
          ></div>
        </div>
      </div>
      <div class="right_center right">
        <div class="headerBox">居住情况统计</div>
        <div class="type">
          <div
            id="addressEcharts"
            ref="addressEcharts"
            style="width: 100%; height: 100%"
          ></div>
        </div>
      </div>
      <div class="right_bottom right">
        <div class="headerBox">老人反馈问题</div>
        <div class="type flex1" style="overflowx: auto">
          <div class="li" v-for="(item, index) in fkwt" :key="index">
            <div class="img"></div>
            <div class="txt" style="width: 15%">
              {{ item.name }}
            </div>
            <div class="txt">
              {{ item.evaluateTypeId == 26 ? "信息回访" : "走访探视" }}
            </div>
            <div class="txt">{{ item.feedback }}</div>
            <div class="time">{{ item.visitTime }}</div>
          </div>
          <!-- <div class="li">
              <div class="img">2</div>
              <div class="txt" style="width: 15%">张晓</div>
              <div class="txt">走访探望</div>
              <div class="txt">希望服务得到改善</div>
              <div class="time">2020-12-06 09:36</div>
          </div>
          <div class="li">
              <div class="img">3</div>
              <div class="txt" style="width: 15%">张晓</div>
              <div class="txt">走访探望</div>
              <div class="txt">希望服务得到改善</div>
              <div class="time">2020-12-06 09:36</div>
          </div>
          <div class="li">
              <div class="img">4</div>
              <div class="txt" style="width: 15%">张晓</div>
              <div class="txt">走访探望</div>
              <div class="txt">希望服务得到改善</div>
              <div class="time">2020-12-06 09:36</div>
          </div> -->
        </div>
      </div>
    </div>
    <div class="serach_wrapper">
      <el-input
        v-model="keyword"
        placeholder="请输入姓名"
        style="width: 120px; margin-right: 12px"
      ></el-input>
      <el-button type="primary" @click="initNameMarker">搜索</el-button>
    </div>

    <div class="addFrom">
      <el-dialog
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        width="990px"
        :before-close="handleClose"
      >
        <el-steps :active="stepIndex" align-center v-show="stepIndex != 0">
          <el-step
            ><span slot="icon" @click="changeStep(1)">基本信息</span></el-step
          >
          <!-- <el-step
          ><span slot='icon' @click='changeStep(2)'
          >信息回访</span
          ></el-step
          > -->
          <el-step
            ><span slot="icon" @click="changeStep(2)"
              >信息回访记录</span
            ></el-step
          >
          <el-step
            ><span slot="icon" @click="changeStep(3)"
              >上门探望记录</span
            ></el-step
          >
          <!-- <el-step
          ><span slot='icon' @click='changeStep(5)'
          >回访内容</span
          ></el-step
          > -->
        </el-steps>
        <!-- 基本信息 -->
        <div
          class="dialog_content_pane"
          v-show="stepIndex == 0 || stepIndex == 1"
        >
          <el-form
            label-width="100px"
            :model="formData"
            ref="formData"
            disabled
          >
            <el-row>
              <el-col :span="24">
                <el-row
                  style="
                    display: flex;
                    align-items: center;
                    margin-bottom: 20px;
                  "
                >
                  <el-col :span="18">
                    <el-row class="dialog_form_left">
                      <el-col :span="11">
                        <el-form-item label="姓名：" prop="customerName">
                          <el-input v-model="formData.customerName"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="11" :offset="2">
                        <el-form-item label="年龄：">
                          <el-input v-model="formData.age"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="11">
                        <el-form-item label="身份证号：" prop="idCard">
                          <el-input v-model="formData.idCard"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="11" :offset="2">
                        <el-form-item label="性别：">
                          <el-select
                            v-model="formData.gender"
                            placeholder="请选择性别"
                            style="width: 100%"
                          >
                            <el-option label="男" value="0"></el-option>
                            <el-option label="女" value="1"></el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="11">
                        <el-form-item label="出生年月：">
                          <el-input v-model="formData.birthday"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="11" :offset="2">
                        <el-form-item label="手机号：">
                          <el-input v-model="formData.phone"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col
                    :span="6"
                    style="
                      display: flex;
                      flex-direction: column;
                      align-items: flex-end;
                    "
                  >
                    <div class="upImg">
                      <el-upload
                        :action="actionUrl"
                        :show-file-list="false"
                        :on-success="
                          (file, fileList) => {
                            handleAvatarSuccess(file, fileList, 'add')
                          }
                        "
                        :before-upload="beforeAvatarUpload"
                      >
                        <div class="avatar" v-if="imageUrl">
                          <img :src="imageUrl" />
                        </div>
                        <i
                          class="el-icon-plus avatar_uploader avatar-uploader-icon"
                          v-else
                        ></i>
                      </el-upload>
                    </div>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-form-item label="民族：" prop="nation">
              <el-select
                v-model="formData.nation"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option
                  v-for="item in nation"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="生活区域：" prop="lifeArea">
              <el-select
                v-model="formData.lifeArea"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option label="农村" value="2"></el-option>
                <el-option label="城市" value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="用户类型：" prop="minzhengIndex">
              <el-select
                v-model="formData.minzhengIndex"
                placeholder="请选择"
                style="width: 100%"
              >
                <el-option label="散居特困供养人员" value="11"></el-option>
                <el-option label="农村留守老人" value="8"></el-option>
                <el-option label="计划生育特殊家庭成员" value="6"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="老人类别：" prop="oldType">
              <el-select
                v-model="formData.oldType"
                placeholder="请选择老人类型"
                style="width: 100%"
              >
                <el-option label="散居特困供养人员" value="11"></el-option>
                <el-option label="农村留守老人" value="8"></el-option>
                <el-option label="计划生育特殊家庭成员" value="6"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="居住地地址：">
              <!-- <el-row>
                  <el-col :span="4">
                      <el-form-item>
                          <el-select
                              v-model="formData.shengId"
                              placeholder="请选择省"
                              @change="handleProvince"
                              style="width: 100%"
                          >
                              <el-option
                                  v-for="(
                                      item, index
                                  ) in provinceList"
                                  :key="index"
                                  :label="item.name"
                                  :value="item.adcode"
                              >
                              </el-option>
                          </el-select>
                      </el-form-item>
                  </el-col>
                  <el-col :span="4" :offset="1">
                      <el-select
                          v-model="formData.shiId"
                          placeholder="请选择市"
                          @change="handleCity"
                          style="width: 100%"
                      >
                          <el-option
                              v-for="(item, index) in cityList"
                              :key="index"
                              :label="item.name"
                              :value="item.adcode"
                          >
                          </el-option>
                      </el-select>
                  </el-col>
                  <el-col :span="4" :offset="1">
                      <el-select
                          v-model="formData.quId"
                          placeholder="请选择区"
                          @change="handleArea"
                          style="width: 100%"
                      >
                          <el-option
                              v-for="(item, index) in areaList"
                              :key="index"
                              :label="item.name"
                              :value="item.adcode + index"
                          >
                          </el-option>
                      </el-select>
                  </el-col>
                  <el-col :span="4" :offset="1">
                      <el-select
                          v-model="formData.street"
                          placeholder="请选择街道"
                      >
                          <el-option
                              v-for="item in streetList"
                              :key="item.id"
                              :label="item.label"
                              :value="item.id"
                          >
                          </el-option>
                      </el-select>
                  </el-col>
                  <el-col :span="4" :offset="1">
                      <el-select
                          v-model="formData.community"
                          placeholder="请选择社区"
                      >
                          <el-option
                              v-for="item in communityList"
                              :key="item.id"
                              :label="item.label"
                              :value="item.id"
                          >
                          </el-option>
                      </el-select>
                  </el-col>
              </el-row> -->
              <el-input
                v-model="formData.address"
                style="margin-top: 12px"
              ></el-input>
              <div class="map_container">
                <div class="map_left">
                  <p v-for="(item, index) in streetList" :key="index">
                    {{ item.name }}
                  </p>
                </div>
                <!--                                <div-->
                <!--                                    class="map_right"-->
                <!--                                    id="container"-->
                <!--                                    style="width: 100%; height: 300px"-->
                <!--                                ></div>-->
              </div>
            </el-form-item>
          </el-form>
        </div>
        <!-- 信息回访 -->
        <!-- <div class='dialog_content_pane' v-show='stepIndex == 2'>
          <el-form
            ref='returnVisitForm'
            class='return_visit_form'
            :model='returnVisitForm'
            label-width='120px'
          >
            <div class='formheader'>
              <span>老人姓名 夏立根</span>
              <span>电话：12345678910</span>
            </div>
            <el-form-item label='问题：'>
              <el-input
                v-model='returnVisitForm.questionName1'
                placeholder='请输入问题'
              ></el-input>
            </el-form-item>
            <el-form-item label='回复选择：'>
              <el-radio-group
                v-model='returnVisitForm.replySelection1'
              >
                <el-radio label='0'>是</el-radio>
                <el-radio label='1'>否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label='原因：' placeholder='请输入内容'>
              <el-input
                type='textarea'
                :rows='3'
                v-model='returnVisitForm.reason1'
              ></el-input>
            </el-form-item>
            <el-form-item label='问题：'>
              <el-input
                v-model='returnVisitForm.questionName2'
                placeholder='请输入问题'
              ></el-input>
            </el-form-item>
            <el-form-item label='回复选择：'>
              <el-radio-group
                v-model='returnVisitForm.replySelection2'
              >
                <el-radio label='0'>是</el-radio>
                <el-radio label='1'>否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label='原因：' placeholder='请输入内容'>
              <el-input
                type='textarea'
                :rows='3'
                v-model='returnVisitForm.reason2'
              ></el-input>
            </el-form-item>
            <el-form-item label='其他：' placeholder='请输入内容'>
              <el-input
                type='textarea'
                :rows='3'
                v-model='returnVisitForm.other'
              ></el-input>
            </el-form-item>
          </el-form>
        </div> -->

        <!-- 信息回访记录 -->
        <div class="dialog_content_pane" v-show="stepIndex == 2">
          <el-table
            :data="tableDate1"
            tooltip-effect="dark"
            @row-click="openDetails"
            highlight-current-row
            :header-cell-style="{
              background: '#e6e6e6',
              color: '#000',
            }"
            style="width: 100%"
            border
          >
            <el-table-column
              type="index"
              width="50"
              label="序号"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="customerName" label="姓名" align="center">
            </el-table-column>
            <el-table-column prop="age" label="年龄" align="center">
            </el-table-column>
            <el-table-column prop="gender" label="性别" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.gender == 0">男</span>
                <span v-if="scope.row.gender == 1">女</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="minzhengIndex"
              min-width="200"
              label="老人类型"
              align="center"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.minzhengIndex == 11"
                  >散居特困供养人员</span
                >
                <span v-if="scope.row.minzhengIndex == 8">农村留守老人</span>
                <span v-if="scope.row.minzhengIndex == 6"
                  >计划生育特殊家庭成员</span
                >
              </template>
            </el-table-column>
            <el-table-column
              min-width="200"
              label="信息回访时间"
              align="center"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.startTime }}~{{ scope.row.endTime }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="states" label="状态" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.states == 1">已完成</span>
                <span v-if="scope.row.states == 0">未完成</span>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              fixed="right"
              align="center"
              width="200"
            >
              <template slot-scope="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="查看"
                  placement="top-start"
                >
                  <button
                    v-if="check != true"
                    style="color: #000"
                    class="iconfont icon-chakan tabBtn"
                    @click="look1('查看', scope.row.zfpgdQuestionList)"
                  ></button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total1"
          ></el-pagination>
        </div>

        <!-- 上门探望记录 -->
        <div class="dialog_content_pane" v-show="stepIndex == 3">
          <el-table
            :data="tableDate2"
            tooltip-effect="dark"
            @row-click="openDetails"
            highlight-current-row
            @selection-change="handleSelectionChange"
            :header-cell-style="{
              background: '#e6e6e6',
              color: '#000',
            }"
            style="width: 100%"
            border
          >
            <el-table-column
              type="index"
              width="50"
              label="序号"
              align="center"
            >
            </el-table-column>
            <el-table-column prop="customerName" label="姓名" align="center">
            </el-table-column>
            <el-table-column prop="age" label="年龄" align="center">
            </el-table-column>
            <el-table-column prop="gender" label="性别" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.gender == 0">男</span>
                <span v-if="scope.row.gender == 1">女</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="minzhengIndex"
              label="老人类别"
              min-width="200"
              align="center"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.minzhengIndex == 11"
                  >散居特困供养人员</span
                >
                <span v-if="scope.row.minzhengIndex == 8">农村留守老人</span>
                <span v-if="scope.row.minzhengIndex == 6"
                  >计划生育特殊家庭成员</span
                >
              </template>
            </el-table-column>
            <el-table-column
              min-width="200"
              label="走访探望时间"
              align="center"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.startTime }}~{{ scope.row.endTime }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="states" label="状态" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.states == 0">未完成</span>
                <span v-if="scope.row.states == 1">已完成</span>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              fixed="right"
              align="center"
              width="200"
            >
              <template slot-scope="scope">
                <el-tooltip
                  class="item"
                  effect="dark"
                  content="查看"
                  placement="top-start"
                >
                  <button
                    style="color: #000"
                    class="iconfont icon-chakan tabBtn"
                    @click="look2(scope.row.id)"
                  ></button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange1"
            @current-change="handleCurrentChange1"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total1"
          ></el-pagination>
        </div>

        <!-- 反馈问题 -->
        <!-- <div class='dialog_content_pane' v-show='stepIndex == 5'>
          <el-table
            :data='tableDate3'
            tooltip-effect='dark'
            @row-click='openDetails'
            highlight-current-row
            @selection-change='handleSelectionChange'
            :header-cell-style="{
                            background: '#e6e6e6',
                            color: '#000',
                        }"
            style='width: 100%'
            border
          >
            <el-table-column
              type='selection'
              width='50'
              align='center'
              @selection-change='handleSelectionChange'
            >
            </el-table-column>
            <el-table-column type='index' width='50' align='center'>
            </el-table-column>
            <el-table-column
              prop='returnName'
              label='反馈内容'
              align='center'
            >
            </el-table-column>
            <el-table-column
              prop='returnStatus'
              label='图片'
              align='center'
            >
            </el-table-column>
            <el-table-column
              prop='returnTime'
              label='反馈时间'
              align='center'
            >
            </el-table-column>
            <el-table-column
              label='操作'
              align='center'
              width='200px'
            >
              <template slot-scope='scope'>
                <el-tooltip
                  class='item'
                  effect='dark'
                  content='指派'
                  placement='top-start'
                >
                  <button
                    style='color: #000'
                    class='iconfont el-icon-thumb tabBtn'
                    @click="look3('指派', scope.row)"
                  ></button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change='handleSizeChange'
            @current-change='handleCurrentChange'
            :current-page='currentPage'
            :page-sizes='[10, 20, 50, 100]'
            :page-size='10'
            layout='total, sizes, prev, pager, next, jumper'
            :total='total1'
          ></el-pagination>
        </div> -->
      </el-dialog>
      <el-dialog
        title="机构点详情"
        :visible.sync="sereyVisiable"
        width="70%"
        :before-close="closeWindow"
      >
        <div class="dialog_content">
          <el-form
            label-position="left"
            label-width="120px"
            ref="formData"
            :model="formData1"
          >
            <el-row>
              <el-col :span="10">
                <el-form-item label="机构编码" prop="statNum">
                  <el-input
                    disabled
                    v-model.trim="formData1.statNum"
                    placeholder="请输入机构编码"
                  ></el-input>
                </el-form-item>
                <el-form-item label="站点名称" prop="statName">
                  <el-input
                    disabled
                    v-model.number="formData1.statName"
                    placeholder="请输入站点名称"
                  ></el-input>
                </el-form-item>
                <el-form-item label="机构类型" prop="statType">
                  <el-select
                    disabled
                    v-model="formData1.statType"
                    placeholder="请选择机构类型"
                    style="width: 100%"
                  >
                    <!-- orgList -->
                    <el-option
                      v-for="item in orgList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="机构电话：" prop="phone">
                  <el-input
                    disabled
                    v-model.number="formData1.phone"
                    :maxlength="11"
                    placeholder="请输入机构电话"
                  ></el-input>
                </el-form-item>
                <el-form-item label="区域名称" prop="areaId">
                  <el-input v-model="formDate.orgName" disabled></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="13" :offset="1">
                <el-form-item label="上传图片" prop="photo" align="left">
                  <el-upload disabled :action="baseUrl" :show-file-list="false">
                    <div>
                      <div class="avatar" v-if="formData1.photo != ''">
                        <img
                          :src="
                            formData1.photo == '../../assets/img/user.png'
                              ? ''
                              : formData1.photo
                          "
                        />
                      </div>
                      <i
                        v-else
                        class="el-icon-plus avatar_uploader avatar-uploader-icon"
                      ></i>
                    </div>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label="机构地点：">
              <el-button
                type="success"
                class="button"
                size="mmedium"
                style="margin-bottom: 25px"
                @click="mapTap"
                >显示位置</el-button
              >
              <div v-show="showMap">
                <el-row>
                  <el-col :span="4">
                    <el-form-item>
                      <el-select
                        v-model="formData1.provinceId"
                        placeholder="请选择省"
                        disabled
                        style="width: 100%"
                        ref="selectShengChange"
                      >
                        <el-option
                          v-for="(item, index) in provinceList"
                          :key="index"
                          :label="item.name"
                          :value="item.adcode"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="4" :offset="1">
                    <el-select
                      v-model="formData1.cityId"
                      placeholder="请选择市"
                      disabled
                      ref="selectShiChange"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="(item, index) in cityList"
                        :key="index"
                        :label="item.name"
                        :value="item.adcode"
                      >
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="4" :offset="1">
                    <el-select
                      v-model="formData1.zoneId"
                      placeholder="请选择区"
                      disabled
                      ref="selectQuChange"
                      style="width: 100%"
                    >
                      <el-option
                        v-for="(item, index) in areaList"
                        :key="index"
                        :label="item.name"
                        :value="item.adcode"
                      >
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="4" :offset="1">
                    <el-select
                      v-model="formData1.streetId"
                      placeholder="请选择街道"
                      disabled
                      ref="selectJiedaoChange"
                    >
                      <el-option
                        v-for="(item, index) in streetList"
                        :key="index"
                        :label="item.name"
                        :value="item.adcode + index"
                      >
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="4" :offset="1">
                    <el-select
                      v-model="formData1.shequId"
                      placeholder="请选择社区"
                      disabled
                      ref="selectShequChange"
                    >
                      <el-option
                        v-for="item in communityList"
                        :key="item.id"
                        :label="item.address"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </el-col>
                </el-row>
                <input
                  v-model.trim="formData1.address"
                  disabled
                  id="tipinput"
                  class="el-input__inner"
                  style="width: 96%"
                  @focus="getMap('tipinput')"
                  placeholder="请输入关键字"
                  autocomplete="off"
                />
              </div>
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>
      <!-- 信息回访记录查看 -->
      <el-dialog title="查看" :visible.sync="dialogVisible2" width="990px">
        <el-form label-width="120px">
          <div v-for="(item, index) in quList" :key="index">
            <el-form-item label="问题：">
              <el-input
                disabled
                :value="item.questionName"
                placeholder="请输入问题"
              ></el-input>
            </el-form-item>
            <el-form-item label="回复选择：">
              <el-radio-group disabled :value="item.replySelection">
                <el-radio label="0">是</el-radio>
                <el-radio label="1">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="原因：" placeholder="请输入内容">
              <el-input
                disabled
                type="textarea"
                :rows="3"
                :value="item.reason"
              ></el-input>
            </el-form-item>
          </div>
          <!-- <el-form-item label='其他：' placeholder='请输入内容'>
            <el-input
              type='textarea'
              :rows='3'
              v-model='returnLookForm.other'
            ></el-input>
          </el-form-item> -->
        </el-form>
      </el-dialog>

      <!-- 上门探望查看 -->
      <el-dialog title="查看" :visible.sync="dialogVisible3" width="800px">
        <table
          ref="print"
          border="1"
          :model="objTanWang"
          cellspacing="0"
          cellpadding="0"
          style="border-collapse: collapse; text-align: center; width: 100%"
        >
          <tr style="height: 60px">
            <td colspan="8">农村特殊困难老年人走访、探望情况登记表</td>
          </tr>
          <tr style="height: 60px">
            <td colspan="2" width="25%" style="background: #e0d6e0">
              被探访人姓名
            </td>
            <td colspan="2">
              {{ objTanWang.name }}
              <!-- 李倾 -->
            </td>
            <td colspan="2" style="background: #e0d6e0">探访人姓名</td>
            <td colspan="2">
              {{ objTanWang.serverPersoName }}
            </td>
          </tr>
          <tr style="height: 60px">
            <td colspan="2" style="background: #e0d6e0; width: 50%">
              探访时间
            </td>
            <td colspan="2" style="width: 50%">
              {{ objTanWang.visitTime }}
              <!-- 2020-10-31 15:30 -->
            </td>
            <td colspan="2" style="background: #e0d6e0">探访地点</td>
            <td colspan="2">
              {{ objTanWang.address }}
            </td>
          </tr>
          <tr style="height: 100px">
            <td colspan="2" style="background: #e0d6e0">老人服务需求</td>
            <td colspan="6">
              <el-checkbox-group disabled v-model="objTanWang.esElderlyDemand">
                <el-checkbox label="0">安全巡查 </el-checkbox>
                <el-checkbox label="1">生活资料 </el-checkbox>
                <el-checkbox label="2">文化娱乐 </el-checkbox>
                <el-checkbox label="3">精神慰藉 </el-checkbox>
                <el-checkbox label="4">其他服务 </el-checkbox>
              </el-checkbox-group>
            </td>
          </tr>
          <tr style="height: 100px">
            <td colspan="2" style="background: #e0d6e0">探视活动情况记录</td>
            <td colspan="6">
              {{ objTanWang.esVisitingRecord }}
            </td>
          </tr>
          <tr style="height: 100px">
            <td colspan="2" style="background: #e0d6e0">健康状况</td>
            <td colspan="6">
              {{ objTanWang.esHealth == 0 ? "有" : "无" }}
            </td>
          </tr>
          <tr style="height: 100px">
            <td colspan="2" style="background: #e0d6e0">老人自理类别</td>
            <td colspan="6">
              <el-checkbox-group
                disabled
                v-model="objTanWang.elderlyCategory"
                style="font-size: 30px"
              >
                <el-checkbox label="0">自理 </el-checkbox>
                <el-checkbox label="1">失能 </el-checkbox>
                <el-checkbox label="2">半失能 </el-checkbox>
                <el-checkbox label="3">失智 </el-checkbox>
                <el-checkbox label="4">轻度依赖 </el-checkbox>
                <el-checkbox label="5">重度依赖 </el-checkbox>
                <el-checkbox label="6">不能自理 </el-checkbox>
              </el-checkbox-group>
            </td>
          </tr>
          <tr style="height: 100px" v-if="objTanWang.esHealth == 0">
            <td colspan="2" style="background: #e0d6e0">听力状况</td>
            <td colspan="6">
              <el-radio-group
                disabled
                type="kind"
                v-model="objTanWang.hearingStatus"
              >
                <el-radio v-model="addForm.hearingStatus" label="0"
                  >良好
                </el-radio>
                <el-radio v-model="addForm.hearingStatus" label="1"
                  >一般
                </el-radio>
                <el-radio v-model="addForm.hearingStatus" label="2"
                  >很大声才能听见
                </el-radio>
                <el-radio v-model="addForm.hearingStatus" label="3"
                  >听不见
                </el-radio>
              </el-radio-group>
            </td>
          </tr>
          <tr style="height: 200px" v-if="objTanWang.esHealth == 0">
            <td colspan="2" style="background: #e0d6e0">病史</td>
            <td colspan="6">
              <el-checkbox-group
                disabled
                v-model="objTanWang.medicalHistory"
                style="font-size: 30px"
              >
                <el-checkbox label="0">健康 </el-checkbox>
                <el-checkbox label="1">高血压 </el-checkbox>
                <el-checkbox label="2">糖尿病 </el-checkbox>
                <el-checkbox label="3">冠心病 </el-checkbox>
                <el-checkbox label="4">恶性肿瘤 </el-checkbox>
                <el-checkbox label="5">结核病 </el-checkbox>
                <el-checkbox label="6">肝炎 </el-checkbox>
                <el-checkbox label="7">脑卒中 </el-checkbox>
                <el-checkbox label="8">精神疾病 </el-checkbox>
                <el-checkbox label="9">脑血栓 </el-checkbox>
                <el-checkbox label="10">慢性阻塞性肺疾病 </el-checkbox>
                <el-checkbox label="11">慢性支气管炎 </el-checkbox>
                <el-checkbox label="12">帕金森综合症 </el-checkbox>
                <el-checkbox label="13">腰间盘突出 </el-checkbox>
                <el-checkbox label="14">心脏病 </el-checkbox>
                <el-checkbox label="15">肺气肿 </el-checkbox>
                <el-checkbox label="16">风湿病 </el-checkbox>
                <el-checkbox label="17">脑中风 </el-checkbox>
                <el-checkbox label="18">高脂血症 </el-checkbox>
                <el-checkbox label="19">哮喘 </el-checkbox>
                <el-checkbox label="20">意外伤害 </el-checkbox>
                <el-checkbox label="21">其他 </el-checkbox>
              </el-checkbox-group>
            </td>
          </tr>
          <tr style="height: 100px">
            <td colspan="2" style="background: #e0d6e0">图片</td>
            <td colspan="6">
              <!-- {{name}} -->
              <div
                style="
                  height: 100px;
                  width: 570px;
                  display: flex;
                  padding-left: 10%;
                "
              >
                <div
                  style="width: 20%; margin: auto 10px"
                  v-for="(item, index) in inmageList"
                  :key="index"
                >
                  <el-image v-if="item" :src="item"></el-image>
                </div>
                <!-- src="https://fuss10.elemecdn.com/a/3f/3302e58f9a181d2509f3dc0fa68b0jpeg.jpeg" -->
              </div>
            </td>
          </tr>
          <tr style="height: 60px">
            <td colspan="2" style="background: #e0d6e0">
              被走访、探望人满意度情况
            </td>
            <td colspan="6">
              {{ objTanWang.esSatisfied == 1 ? "不满意" : "满意" }}
            </td>
          </tr>
        </table>
        <el-button
          type="primary"
          style="display: block; margin: 20px auto"
          @click="dy"
          >打印
        </el-button>
      </el-dialog>

      <!-- 指派 -->
      <el-dialog title="指派" :visible.sync="dialogVisible4" width="800px">
        <el-form :model="assign" label-width="130px">
          <el-row :gutter="20">
            <el-col :span="10">
              <el-form-item label="反映人：">
                <el-input
                  v-model="assign.person"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="手机号：">
                <el-input
                  v-model="assign.phone"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="10">
              <el-form-item label="反映渠道：">
                <el-input
                  v-model="assign.feedbackType"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="反馈时间：">
                <el-date-picker
                  v-model="assign.feedbackTime"
                  type="datetime"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="10">
              <el-form-item label="是否为议题处置：">
                <el-radio-group v-model="assign.isFeedbackName">
                  <el-radio label="0">是</el-radio>
                  <el-radio label="1">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="是否通知民政：">
                <el-radio-group v-model="assign.isRecord">
                  <el-radio label="0">是</el-radio>
                  <el-radio label="1">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="居住地址：">
            <el-input v-model="assign.address" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item label="反馈内容：">
            <el-input
              v-model="addForm.feedbackTxt"
              type="textarea"
              :rows="3"
            ></el-input>
          </el-form-item>
          <el-form-item label="附件：" placeholder="请输入内容">
            <div class="upImg">
              <el-upload
                :action="actionUrl"
                :show-file-list="false"
                :on-success="
                  (file, fileList) => {
                    handleAvatarSuccess(file, fileList, 'add')
                  }
                "
                :before-upload="beforeAvatarUpload"
              >
                <div class="avatar" v-if="imageUrl">
                  <img :src="imageUrl" />
                </div>
                <i
                  class="el-icon-plus avatar_uploader avatar-uploader-icon"
                  v-else
                ></i>
              </el-upload>
            </div>
          </el-form-item>
          <el-row :gutter="20">
            <el-col :span="10">
              <el-form-item label="选择部门：">
                <el-select
                  multiple
                  collapse-tags
                  style="width: 100%"
                  v-model="assign.depart1"
                  placeholder="请选择"
                >
                  <el-option label="xx1部" value="0"></el-option>
                  <el-option label="xx2部" value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="选择人员：">
                <el-select
                  multiple
                  collapse-tags
                  style="width: 100%"
                  v-model="assign.name1"
                  placeholder="请选择"
                >
                  <el-option label="xxx1" value="0"></el-option>
                  <el-option label="xxx2" value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="10">
              <el-form-item label="姓名：">
                <el-input v-model="assign.name" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="手机号：">
                <el-input
                  v-model="assign.namePhone"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer">
          <el-button type="primary" @click="save">确定</el-button>
          <el-button @click="dialogVisible4 = false">取消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import baseURL from "@/api/baseURL"
import request from "@/utils/request.js"

export default {
  name: "visualized",
  data() {
    return {
      fen: [],
      state: [],
      clickIndex: 1,
      infoTisp: false,
      isLoading: false,
      keyword: "", //搜索
      onFullScreen: false, // 是否全屏
      oldtypeLits: [],
      state: {
        //项目状态
        distribute: "",
        assessApproval: "",
        constructionApproval: "",
        toBeEvaluate: "",
        finishEvaluate: "",
        completed: "",
      },
      markers: [],
      // 弹窗
      dialogVisible2: false,
      stepIndex: 1,
      dialogTitle: "",
      dialogVisible: false,
      sereyVisiable: false,
      dialogVisible3: false,
      dialogVisible4: false,
      formData: {
        //基本信息
        name: "", //姓名
        sex: "", //性别
        phone: "", //联系方式
        idCode: "", //身份证号
        age: "", //年龄
        oldType: "", //老人类型
        shengId: "", //省
        shiId: "", //市
        quId: "", //区
        street: "", //街道
        community: "", //社区
        address: "", //居住地址
        photo: "", //图片
        nation: "", //民族
      },
      formData1: {},
      formDate: {},
      returnVisitForm: {
        // 回访
        questionName1: "",
        replySelection1: "",
        reason1: "",
        questionName2: "",
        replySelection2: "",
        reason2: "",
        other: "",
      },
      // 指派
      assign: {
        person: "",
        phone: "",
        feedbackType: "",
        feedbackTime: "",
        isFeedbackName: "",
        isRecord: "",
        address: "",
        feedbackTxt: "",
        depart1: "",
        name1: "",
        name: "",
        namePhone: "",
      },
      currentRow: null,
      // 图片预览
      dialogImageUrl: "",
      // 上传图片地址
      actionUrl: baseURL + "/ypt/controller/uploadController/info/uploadPhoto",
      imageUrl: "",
      addForm: {
        health: "",
        serviceDemand: [],
        selfCare: [],
        hraring: "",
        case: [],
      },
      // 表单测试数据
      tableDate: [
        {
          name: "夏立根",
          idCard: "340104193605253549",
          birthDate: "1936-05",
          sex: "1",
          phone: "13955130219",
          nation: "乌孜别克族",
          livingArea: "1",
          userType: "13",
          olderType: "xxxx",
          address: "安徽省合肥市蜀山区",
        },
      ],
      tableDate1: [],
      quList: [], //回访问题列表
      objTanWang: {}, //探望记录详情
      tableDate2: [],
      tableDate3: [],
      nation: [
        "汉族",
        "蒙古族",
        "回族",
        "藏族",
        "维吾尔族",
        "苗族",
        "彝族",
        "壮族",
        "布依族",
        "朝鲜族",
        "满族",
        "侗族",
        "瑶族",
        "白族",
        "土家族",
        "哈尼族",
        "哈萨克族",
        "傣族",
        "黎族",
        "傈僳族",
        "佤族",
        "畲族",
        "高山族",
        "拉祜族",
        "水族",
        "东乡族",
        "纳西族",
        "景颇族",
        "柯尔克孜族",
        "土族",
        "达斡尔族",
        "仫佬族",
        "羌族",
        "布朗族",
        "撒拉族",
        "毛南族",
        "仡佬族",
        "锡伯族",
        "阿昌族",
        "普米族",
        "塔吉克族",
        "怒族",
        "乌孜别克族",
        "俄罗斯族",
        "鄂温克族",
        "德昂族",
        "保安族",
        "裕固族",
        "京族",
        "塔塔尔族",
        "独龙族",
        "鄂伦春族",
        "赫哲族",
        "门巴族",
        "珞巴族",
        "基诺族",
      ],
      provinceList: [], //省列表
      cityList: [], //市列表
      areaList: [], //区列表
      streetList: [], //街道列表
      communityList: [], //社区列表
      currentPage: 1, //默认展示第一页
      total: 0, //总数据
      total1: 0,
      query: {
        pageNo: 1,
        pageSize: 10,
      },
      query1: {
        pageNo: 1,
        pageSize: 10,
      },
      olderId: "",
      chartOne: null,
      chartTwo: null,
      chartThree: null,
      chartFour: null,
      chartFive: null,
      fkwt: [],
      showMap: false,
      inmageList: [],
      orgList: [{ value: "1", label: "居家养老机构" }],
    }
  },
  filters: {
    //时间格式化
    formatDate(date) {
      let dt = new Date(date)
      let dty = dt.getFullYear()
      let dtm = (dt.getMonth() + 1).toString().padStart(2, "0")
      let dtd = dt.getDate().toString().padStart(2, "0")
      let dth = dt.getHours().toString().padStart(2, "0")
      let dtmi = dt.getMinutes().toString().padStart(2, "0")
      let dts = dt.getSeconds().toString().padStart(2, "0")
      return dty + "-" + dtm + "-" + dtd
    },
  },
  created() {
    this.$nextTick(() => {})
    this.baseUrl = baseURL + "/ypt/controller/uploadController/info/uploadPhoto"
  },

  _methods: {
    //老人反馈
    async lrfkwt() {
      await request({
        url: "/jjyl/admin/zfpgdContent/info/findListbyOld",
        method: "POST",
        data: {
          pageNo: 1,
          pageSize: -1,
          feedback: "1",
          states: "1",
        },
      }).then((res) => {
        if (res.code == 200) {
          console.log(res, "fwwt")
          if (res.content == null || res.content == "null") {
            let lrfkwt = []
            return
          }
          this.fkwt = res.content.list
          // if (this.fkwt.length > 4) {
          //   this.fkwt.length = 4
          // }
          console.log(this.fkwt, "length")
          // let fuwu = [
          //     res.content.ones,
          //     res.content.twos,
          //     res.content.threes,
          //     res.content.fours,
          // ];
          // this.addressType(juzhu);
          // console.log(this.state)
        } else if (res.code == "10004") {
          this.$message.error(res.message)
          this.$router.push("/login")
        }
      })
    },

    //老人服务类型统计
    async fwlbtj() {
      await request({
        url: "/jjyl/admin/zfCustomer/info/findServeType",
        method: "POST",
        data: {
          pageNo: 1,
          pageSize: 10,
        },
      }).then((res) => {
        if (res.code == 200) {
          if (res.content != null || res.content != "null") {
            this.servicesType(res.content)
            return
          }
        } else if (res.code == "10004") {
          this.$message.error(res.message)
          this.$router.push("/login")
        }
      })
    },

    //老人居住
    async lrzu() {
      await request({
        url: "/jjyl/admin/zfCustomer/info/findJuzhuCommunity",
        method: "POST",
        data: {
          pageNo: 1,
        },
      }).then((res) => {
        if (res.code == 200) {
          console.log(res, "juzhu")
          if (res.content == null || res.content == "null") {
            let juzhu = []
            return
          }
          let juzhu = [
            res.content.ones,
            res.content.twos,
            res.content.threes,
            res.content.fours,
          ]
          this.addressType(juzhu)
          // console.log(this.state)
        } else if (res.code == "10004") {
          this.$message.error(res.message)
          this.$router.push("/login")
        }
      })
    },

    //老人类别
    async lrfw() {
      await request({
        url: "/jjyl/admin/zfCustomer/info/findOldTpye",
        method: "POST",
        data: {
          pageNo: 1,
        },
      }).then((res) => {
        if (res.code == 200) {
          if (res.content == null || res.content == "null") {
            this.leibie = []
            return
          }
          let leibie = [
            res.content[0].ones,
            res.content[0].twos,
            res.content[0].threes,
          ]
          this.orderType(leibie)
          // console.log(this.state)
        } else if (res.code == "10004") {
          this.$message.error(res.message)
          this.$router.push("/login")
        }
      })
    },
    //分类统计
    fenltj() {
      request({
        url: "/jjyl/admin/zfCustomer/info/findAgeAndSex",
        method: "POST",
        data: {
          pageNo: 1,
        },
      }).then((res) => {
        if (res.code == 200) {
          console.log(res)

          if (res.content == null || res.content == "null") {
            this.fen = []
            return
          }
          let fen = [
            res.content[0].age50,
            res.content[0].age60,
            res.content[0].age70,
            res.content[0].age80,
            res.content[0].age90,
            res.content[0].age100,
          ]
          this.ageType(fen) //年龄
          this.fen = fen
          console.log(this.fen, "111")
          //性别
          let sex = [res.content[0].male, res.content[0].female]
          this.sex = sex
        } else if (res.code == "10004") {
          this.$message.error(res.message)
          this.$router.push("/login")
        }
      })
    },

    async project() {
      await request({
        url: "/jjyl/admin/zfCustomer/info/findCustomers",
        method: "POST",
        data: {
          pageNo: 1,
        },
      }).then((res) => {
        if (res.code == 200) {
          console.log(res)
          if (res.content == null || res.content == "null") {
            this.state = []
            return
          }
          this.state = res.content
          console.log(this.state)
        } else if (res.code == "10004") {
          this.$message.error(res.message)
          this.$router.push("/login")
        }
      })
    },

    getVisitList() {
      request({
        url: "/jjyl/admin/zfpgdContent/info/findbyOld",
        method: "POST",
        data: {
          oldId: this.olderId,
          pageNo: this.query.pageNo,
          pageSize: this.query.pageSize,
          serviceType: 1,
        },
      }).then((res) => {
        if (res.code == 200) {
          if (res.content && res.content.list) {
            this.tableDate1 = res.content.list
            this.total1 = res.content.count
          } else {
            this.tableDate1 = []
            this.total1 = 0
          }
        }
      })
    },
    gettypeList() {
      let query = {
        pageNum: 1,
        pageSize: 999,
        dictType: "customer.type",
      }
      this.$http
        .request({
          url: "/rbac/system/dict/data/list",
          method: "get",
          params: query,
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.rows != null) {
              this.oldtypeLits = res.rows
              this.oldtypeLits.forEach((item) => {
                item.dictCode = String(item.dictCode)
              })
            }
          }
        })
    },
    //探望记录列表
    getTanWangList() {
      request({
        url: "/jjyl/admin/zfpgdContent/info/findbyOld",
        method: "POST",
        data: {
          oldId: this.olderId,
          pageNo: this.query1.pageNo,
          pageSize: this.query1.pageSize,
          serviceType: 0,
        },
      }).then((res) => {
        if (res.code == 200) {
          if (res.content && res.content.list) {
            this.tableDate2 = res.content.list
            this.total1 = res.content.count
          } else {
            this.tableDate2 = []
            this.total2 = 0
          }
        }
      })
    },
    // 点击步骤条跳转
    changeStep(val) {
      if (val == 2) {
        //信息回访数据
        this.getVisitList()
      } else if (val == 3) {
        //上门探望记录
        this.getTanWangList()
      }
      this.stepIndex = val
      // console.log(this.stepIndex);
    },

    // 信息回访记录查看
    look1(title, list) {
      this.quList = list
      this.dialogVisible2 = true
    },

    // 上门探望查看
    async look2(id) {
      await request({
        url: "/jjyl/admin/zfpgdContent/info/getContentById",
        method: "POST",
        data: { id: id },
      }).then((res) => {
        if (res.code == 200) {
          this.objTanWang = res.content
        }
      })
      this.dialogVisible3 = true
    },

    // 指派
    look3() {
      this.dialogVisible4 = true
    },

    // 保存
    save() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.dialogVisible = false
        }
      })
    },
    // 打印
    dy() {
      this.$print(this.$refs.print)
    },
    //每页请求数据
    handleSizeChange(val) {
      this.query.pageNo = val
      this.getVisitList()
    },
    //请求第几数据
    handleCurrentChange(val) {
      this.query.pageNo = val
      this.getVisitList()
    },

    //每页请求数据
    handleSizeChange1(val) {
      this.query1.pageNo = val
      this.getTanWangList()
    },
    //请求第几数据
    handleCurrentChange1(val) {
      this.query1.pageNo = val
      this.getTanWangList()
    },

    // 行点击选中
    openDetails(row, event, column, cell) {
      this.row = row
      this.column = column
    },
    handleSelectionChange(rows) {
      this.multipleSelection = rows
    },

    handleSelectionChange(data) {
      this.selectedData = data
    },
    // 弹框关闭
    handleClose() {
      this.stepIndex = 1
      this.dialogVisible = false
    },

    // 图片上传 start
    handleAvatarSuccess(res) {
      this.imageUrl = res.content
      this.addForm.img = res.content
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png"
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!")
        return
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!")
        return
      }
    },
    handlePicturePreview(file) {
      this.dialogVisible1 = true
      this.dialogImageUrl = file.url
    },
    // 图片上传 end
    // 控制全屏展示
    showFullScreen() {
      this.onFullScreen = !this.onFullScreen
      if (this.onFullScreen) {
        var docElm = document.documentElement
        if (docElm.requestFullscreen) {
          docElm.requestFullscreen()
        } else if (docElm.msRequestFullscreen) {
          docElm = document.body //overwrite the element (for IE)
          docElm.msRequestFullscreen()
        } else if (docElm.mozRequestFullScreen) {
          docElm.mozRequestFullScreen()
        } else if (docElm.webkitRequestFullScreen) {
          docElm.webkitRequestFullScreen()
        }
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
        }
      }
    },
    FullCreeen(element) {
      let el = document.getElementById("bigdata")
      let rfs =
        el.requestFullScreen ||
        el.webkitRequestFullScreen ||
        el.mozRequestFullScreen ||
        el.msRequestFullScreen
      if (typeof rfs != "undefined" && rfs) {
        rfs.call(el)
      } else if (typeof window.ActiveXObject != "undefined") {
        let wscript = new ActiveXObject("WScript.Shell")
        if (wscript != null) {
          wscript.SendKeys("{F11}")
        }
      }
    },

    // 分类统计
    // 分类统计点击事件
    changeClick(val) {
      console.log(val)
      this.clickIndex = val
      if (val == 1) {
        console.log(this.fen)
        this.ageType(this.fen)
      }
      if (val == 2) {
        this.sexType(this.sex)
      }
    },

    // 年龄
    ageType(fen) {
      this.chartOne = this.$echarts.init(this.$refs.typeEcharts)
      // 编写echart参数
      let option = {
        color: [
          "#DF38C1",
          "#9279E2",
          "#1999F7",
          "#87BF62",
          "#D1364B",
          "#FFB652",
        ],
        tooltip: {
          trigger: "item",
        },
        legend: {
          bottom: 0,
          left: "center",
          itemGap: 20,
          show: false,
          data: ["50-59", "60-69", "70-79", "80-89", "90-99", "100以上"],
          textStyle: {
            color: "#fff",
          },
        },
        series: [
          {
            type: "pie",
            radius: ["30%", "50%"],
            center: ["50%", "60%"],
            data: [
              { value: fen[0], name: "50-59" },
              { value: fen[1], name: "60-69" },
              { value: fen[2], name: "70-79" },
              { value: fen[3], name: "80-89" },
              { value: fen[4], name: "90-99" },
              { value: fen[5], name: "100以上" },
            ],
          },
        ],
      }
      // 设置图表的参数
      this.chartOne.setOption(option)
    },

    // 性别
    sexType(sex) {
      this.chartTwo = this.$echarts.init(this.$refs.typeEcharts)
      // 编写echart参数
      let option = {
        color: ["#DF38C1", "#9279E2"],
        tooltip: {
          trigger: "item",
        },
        legend: {
          bottom: 0,
          left: "center",
          itemGap: 20,
          data: ["男", "女"],
          show: false,
          textStyle: {
            color: "#fff",
          },
        },
        series: [
          {
            type: "pie",
            radius: ["30%", "50%"],
            center: ["50%", "60%"],
            data: [
              { value: sex[0], name: "男" },
              { value: sex[1], name: "女" },
            ],
          },
        ],
      }
      // 设置图表的参数
      this.chartTwo.setOption(option)
    },

    // 老人服务类型统计
    servicesType(data) {
      this.chartThree = this.$echarts.init(this.$refs.servicesEcharts)
      let option
      option = {
        color: ["#2B94F2", "#FBB828"],
        grid: {
          x: "10%",
          y: "4%",
          bottom: "2%",
          top: "15%",
          containLabel: true,
        },
        tooltip: {
          trigger: "item",
        },
        xAxis: {
          type: "category",
          data: ["信息回访", "走访探视"],
          axisLabel: {
            textStyle: {
              color: "#fff",
            },
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            textStyle: {
              color: "#fff",
            },
          },
        },
        series: [
          {
            data: [data.informationVisit, data.visit],
            type: "bar",
            barWidth: 40,
            raduis: ["50%", "50%"],
            center: ["50%", "50%"],
          },
        ],
      }

      this.chartThree.setOption(option)
    },
    // 老人类别统计
    orderType(leibie) {
      this.chartFour = this.$echarts.init(this.$refs.olderEcharts)
      // 编写echart参数
      let option = {
        color: ["#C129FF", "#41A6FD", "#50BBE1"],
        tooltip: {
          trigger: "item",
          formatter: "{b}<br/>{d}%",
        },
        legend: {
          show: false,
        },
        series: [
          {
            type: "pie",
            radius: ["30%", "50%"],
            center: ["50%", "40%"],
            data: [
              { value: leibie[2], name: "散居特困供养人员" },
              {
                value: leibie[0],
                name: "计划生育特殊困难家庭中的老人",
              },
              { value: leibie[1], name: "农村留守老年人" },
            ],
          },
        ],
      }
      // 设置图表的参数
      this.chartFour.setOption(option)
    },
    // 居住情况统计
    addressType(juzhu) {
      this.chartFive = this.$echarts.init(this.$refs.addressEcharts)
      let option = {
        color: ["#32A5A1"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "none",
          },
        },
        grid: {
          x: "10%",
          y: "4%",
          bottom: "2%",
          top: "15%",
          containLabel: true,
        },
        xAxis: [
          {
            axisLine: {
              show: false,
            },
            axisLabel: {
              color: "#fff",
              interval: 0, //强制显示
            },
            axisLine: {
              lineStyle: {
                color: "#FFF",
                width: 1, //这里是为了突出显示加上的
              },
            },
            data: ["独自居住", "与配偶居住", "与子女居住", "其他"],
          },
        ],
        yAxis: {
          splitLine: {
            //网格线
            lineStyle: {
              type: "dashed", //设置网格线类型 dotted：虚线   solid:实线
            },
            show: true, //隐藏或显示
          },
          axisLabel: {
            color: "#fff",
          },
          nameTextStyle: {
            color: "#fff",
          },
          axisLine: {
            lineStyle: {
              color: "#FFF",
              width: 1, //这里是为了突出显示加上的
            },
          },
          type: "value",
        },
        series: {
          name: "",
          type: "bar",
          barWidth: "20%",
          data: [juzhu[0], juzhu[1], juzhu[2], juzhu[3]],
        },
      }
      // 设置图表的参数
      this.chartFive.setOption(option)
    },

    //  省级地址选择发生改变
    async handleProvince(val) {
      this.cityList = []
      this.areaList = []
      this.streetList = []
      this.formData.shiId = ""
      this.formData.quId = ""
      // let city = await this.getDistrict(val);
      this.cityList = city.districtList
    },
    //市级地址发生改变
    async handleCity(val) {
      this.formData.quId = ""
      this.areaList = []
      this.streetList = []
      // let area = await this.getDistrict(val);
      this.areaList = area.districtList
    },
    //县区级地址发生改变
    async handleArea(val) {
      this.streetList = []
      // val = val.replace(/.$/, "");
      let street = await this.getDistrict(val)
      this.streetList = street.districtList
    },
    // 地址 end
    loadMap() {
      //地图加载
      return new Promise((resolve, reject) => {
        this.map = new AMap.Map("container", {
          resizeEnable: true,
          mapStyle: "amap://styles/darkblue",
          zoom: 9,
          //center: [114.930934, 30.474891],
        })
        if (
          this.$store.state.orgAreaLevel == 1 ||
          this.$store.state.orgAreaLevel == 2 ||
          this.$store.state.orgAreaLevel == 3
        ) {
          console.log(
            this.$store.state.orgAreaName,
            "this.$store.state.orgAreaName"
          )
          let cities = [this.$store.state.orgAreaName]
          for (let i = 0; i < cities.length; i++) {
            this.areaBG(this.map, cities[i])
            this.map.setZoom(8)
          }
        } else if (
          this.$store.state.orgAreaLevel == 4 ||
          this.$store.state.orgAreaLevel == 5
        ) {
          console.log("社区，街道", this.$store.state.orgId)

          if (this.$store.state.orgId != 0) {
            this.$http
              .request({
                url: "/rbac/admin/org/info/findOrgById",
                method: "POST",
                data: {
                  id: this.$store.state.orgId,
                },
              })
              .then((res) => {
                var polygonArr = []
                res.content.pointPosition.split(",").forEach((i) => {
                  console.log(i)
                  polygonArr.push(i.split(":"))
                })
                this.polygon = new AMap.Polygon({
                  map: this.map,
                  strokeWeight: 1,
                  path: polygonArr,
                  fillOpacity: 0.3,
                  fillColor: "#2191E6",
                  strokeColor: "#007CDB",
                })
                this.map.setZoomAndCenter(7, [
                  polygonArr[0].lng,
                  polygonArr[0].lat,
                ])
                this.polygon.setMap(this.map)
              })
          }
        }
        resolve()
      })
    },
    areaBG(map, cityName) {
      console.log(cityName, "cityName")
      AMap.service("AMap.DistrictSearch", function () {
        let opts = {
          subdistrict: 0,
          extensions: "all",
          level: "district", // 查询行政级别为市
        }
        // 实例化DistrictSearch
        let district = new AMap.DistrictSearch(opts)
        district.setLevel("district")
        // 行政区查询
        district.search(`${cityName}`, function (status, result) {
          // 获取边界信息
          let bounds = result.districtList[0].boundaries
          let polygons = []
          if (bounds) {
            for (let i = 0, l = bounds.length; i < l; i++) {
              // 生成行政区划polygon
              let polygon = new AMap.Polygon({
                map: map,
                strokeWeight: 1,
                path: bounds[i],
                fillOpacity: 0.3,
                fillColor: "#2191E6",
                strokeColor: "#007CDB",
              })
              polygons.push(polygon)
              console.log(polygon)
            }
          }
        })
      })
    },
    // // 地图打点
    // renderMapMarker(addresses, name = "") {
    //     let self = this;
    //     let geocoder = new AMap.Geocoder({
    //         city: "", //城市设为北京，默认：“全国”
    //     });
    //     var endIcon = new AMap.Icon({
    //         size: new AMap.Size(49, 56),
    //         image: require("../assets/img/end_icon.png"),
    //         imageSize: new AMap.Size(38, 42),
    //     });
    //     geocoder.getLocation(addresses, function (status, result) {
    //         if (status === "complete" && result.geocodes.length) {
    //             for (let i = 0; i < result.geocodes.length; i += 1) {
    //                 let marker = new AMap.Marker({
    //                     position: result.geocodes[i].location,
    //                     icon: endIcon,
    //                 });
    //                 self.markers.push(marker);
    //                 marker.on("mouseover", (e) => {
    //                     marker.setTitle(name);
    //                 });
    //                 marker.on("click", (e) => {
    //                     self.dialogVisible = true;
    //                 });
    //             }
    //             self.map.add(self.markers);
    //             self.map.setFitView(self.markers);
    //         }
    //     });
    // },
    //获取地址
    getDistrict(name = "中国", params = null) {
      let self = this
      return new Promise((resolve, reject) => {
        var opts = {
          subdistrict: 1,
          extensions: "all",
          showbiz: false, //最后一级返回街道信息
        }
        let district = new AMap.DistrictSearch(opts)
        let geocoder = new AMap.Geocoder({
          city: "",
          radius: 1000, //范围，默认：500
        })
        try {
          self.myMap.remove(self.marker)
        } catch (err) {
          console.log(err)
        }

        self.marker = new AMap.Marker()
        district.search(name, (status, result) => {
          if (status == "complete") {
            resolve(result.districtList[0])
            if (this.isMap) {
              this.isMap = false
              return
            }
            let bounds = result.districtList[0].boundaries
            self.polygon = null
          }
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    // 社区地址列表
    getCommityList(val) {
      let self = this
      return new Promise((resolve, reject) => {
        self.$http
          .request({
            url: "/ypt/admin/standardAddress/info/StandardAddressTree",
            method: "POST",
            data: {
              jiedaoId: val,
            },
          })
          .then((res) => {
            if (res.code == 200) {
              if (!res.content) {
                resolve([])
                return
              }
              resolve(res.content)
            } else {
              resolve([])
            }
          })
      }).catch((err) => {
        console.log(err)
      })
    },
    initNameMarker() {
      this.$http
        .request({
          url: "/jjyl/admin/zfCustomer/info/findList",
          method: "POST",
          data: {
            pageSize: -1,
            pageNo: 1,
            name: this.keyword,
          },
        })
        .then((res) => {
          if (res.code == 200) {
            this.isLoading = false
            this.map.remove(this.markers)
            this.markers = []
            res.content.list.forEach((item, index) => {
              item.tubiao = require("../assets/img/a1.png")
              item.typeId = "oldData"
              item.latitude = Number(item.latitude)
              item.longitude = Number(item.longitude)
            })
            this.renderMapMarker(res.content.list)
            this.map.setZoom(9) //解决设置markers zoom无效问题
          } else if (res.code == "10004") {
            this.$message.error(res.message)
            this.$router.push("/login")
          }
        })
    },
    initMarker() {
      this.isLoading = true
      this.$http
        .request({
          url: "/jjyl/admin/zfCustomer/info/findViewList",
          method: "POST",
          data: {
            pageSize: 100,
            pageNo: 1,
          },
        })
        .then((res) => {
          if (res.code == 200) {
            this.isLoading = false
            this.map.remove(this.markers)
            this.markers = []
            res.content.list.forEach((item, index) => {
              item.tubiao = require("../assets/img/a1.png")
              item.typeId = "oldData"
              item.latitude = Number(item.latitude)
              item.longitude = Number(item.longitude)
            })
            this.renderMapMarker(res.content.list)
            //   this.map.setZoom(9) //解决设置markers zoom无效问题
          } else if (res.code == "10004") {
            this.$message.error(res.message)
            this.$router.push("/login")
          }
        })
    },
    getServation() {
      this.isLoading = true
      this.map.remove(this.markers)
      this.markers = []
      this.$http
        .request({
          url: "/jjyl/admin/zfCustomer/info/findListServiceStation",
          method: "POST",
          data: {},
        })
        .then((res) => {
          if (res.code == 200) {
            this.isLoading = false
            this.map.remove(this.markers)
            this.markers = []
            res.content.forEach((item, index) => {
              item.tubiao = require("../assets/img/a2.png")
              item.typeId = "fuwuzhan"
              item.latitude = Number(item.latitude)
              item.longitude = Number(item.longitude)
              if (item.latitude && item.longitude) {
                //  self.corporationList.push(item)
              }
            })
            this.renderMapMarker(res.content)
            this.map.setZoom(5) //解决设置markers zoom无效问题
          } else if (res.code == "10004") {
            this.$message.error(res.message)
            this.$router.push("/login")
          }
        })
    },
    renderMapMarker(data) {
      let self = this
      let marker = null
      // this.map.clearMap()
      data.forEach((item) => {
        marker = new AMap.Marker({
          position: [item.longitude, item.latitude],
          icon: new AMap.Icon({
            image: item.tubiao,
            size: new AMap.Size(52, 52),
            imageSize: new AMap.Size(30, 30),
          }),
          // title: item.detailAddress,
          offset: new AMap.Pixel(-13, -30), //往左往上
        })
        console.log(item.longitude, item.latitude)
        self.markers.push(marker)

        marker.on("mouseover", (e) => {
          marker.setTitle(item.name)
        })
        marker.on("click", (e) => {
          // console.log(item, "我选中的数据")
          if (item.typeId == "oldData") {
            self.dialogVisible = true
            this.gettypeList()
            setTimeout(async () => {
              self.getById(item.id)
            }, 50)
            self.olderId = item.id
          }
          if (item.typeId == "fuwuzhan") {
            this.sereyVisiable = true
            self.getById1(item.serviceStation)
          }
        })
      })
      self.map.add(self.markers)
      // self.map.setFitView(self.markers)
      // self.map.setZoom(4)
      self.map.add(self.polygon)
      self.map.setFitView(self.polygon) //视口自适应
      console.log(self.markers, "打点数量")
    },
    getById(id) {
      this.$http
        .request({
          url: "/jjyl/admin/zfCustomer/info/getById",
          method: "POST",
          data: {
            id,
          },
        })
        .then((res) => {
          let data = res.content
          //基本信息
          this.formData.customerName = data.customerName //姓名
          this.formData.gender = data.gender //性别
          this.formData.birthday = data.birthday //姓名
          this.formData.phone = data.phone //联系方式
          this.formData.idCard = data.idCard //身份证号
          this.formData.age = data.age //年龄
          this.formData.oldType = data.minzhengIndex //老人类型
          this.formData.shengId = data.shengId //省
          this.formData.shiId = data.shiId //市
          this.formData.quId = data.quId //区
          this.formData.street = data.street //街道
          this.formData.community = data.community //社区
          this.formData.address = data.address //居住地址
          this.formData.photo = data.photo //图片
          this.formData.nation = data.nation //民族
          this.formData.lifeArea = data.lifeArea //民族
          this.formData.minzhengIndex = String(data.minzhengIndex) //
          console.log(data)
        })
    },
    gatAreaName() {
      // debugger
      this.$http
        .request({
          url: "/ypt/admin/org/info/findOrgByLoginUser",
          method: "POST",
          data: {},
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content != null) {
              this.formData1.areaId = res.content.id
              this.formDate.orgName = res.content.orgName
            }
          }
        })
    },
    getById1(id) {
      this.$http
        .request({
          url: "ypt/admin/serviceStation/info/get",
          method: "POST",
          data: {
            id,
          },
        })
        .then(async (res) => {
          if (res.content) {
            this.formData1 = res.content
            this.formDate.orgName = this.formDate.orgName
            this.formData1.provinceId = String(this.formData1.provinceId)
            this.formData1.cityId = String(this.formData1.cityId)
            this.formData1.zoneId = String(this.formData1.zoneId)
            this.formData1.streetId = String(this.formData1.streetId)
            this.formData1.shequId = Number(this.formData1.shequId)
            let province = await this.getDistrict()
            this.provinceList = province.districtList
            console.log(this.provinceList, "省")
            if (!this.formData1.provinceId) return
            let city = await this.getDistrict(this.formData1.provinceId)
            this.cityList = city.districtList
            if (!this.formData1.cityId) return
            let area = await this.getDistrict(this.formData1.cityId)
            this.areaList = area.districtList
            if (!this.formData1.zoneId) return
            let street = await this.getDistrict(this.formData1.zoneId)
            this.streetList = street.districtList
            if (!this.formData1.streetId) return
            // self.streetChange(self.formData.streetId, true)
            let communityList = await this.getCommityList(
              this.formData1.streetId
            )
            this.communityList = communityList
          } else {
            this.formData1 = {}
          }
        })
    },

    closeWindow() {
      this.sereyVisiable = false
    },
    mapTap() {
      this.showMap = !this.showMap
    },
  },
  get methods() {
    return this._methods
  },
  set methods(value) {
    this._methods = value
  },
  async mounted() {
    await this.initMarker()
    await this.loadMap()
    await this.lrzu()
    await this.lrfw()
    await this.fenltj()
    await this.project()
    await this.fwlbtj()
    await this.lrfkwt()
    await this.gatAreaName()
    let self = this
    // let address = ["庐阳区", "包河区", "长丰县", "肥东县"];
    // address.forEach((item) => {
    //     this.renderMapMarker(item, item);
    // });
    window.addEventListener("resize", () => {
      // 自适应所有echarts
      this.chartOne && this.chartOne.resize()
      this.chartTwo && this.chartTwo.resize()
      this.chartThree && this.chartThree.resize()
      this.chartFour && this.chartFour.resize()
      this.chartFive && this.chartFive.resize()
      const handleResize = () => {
        if (!checkFull()) {
          self.onFullScreen = false
        }
      }
      window.onresize = handleResize

      function checkFull() {
        let isFull =
          document.fullscreenElement ||
          document.mozFullScreenElement ||
          document.webkitFullscreenElement
        if (isFull === undefined) isFull = false
        return isFull
      }
    })
    let arr = [[{ week: 1 }], [{ week: 2 }, { week: 3 }], []]

    // const self = this
    document.addEventListener(
      "fullscreenchange",
      function () {
        self.onFullScreen = document.fullscreenElement == null ? false : true
      },
      false
    )

    document.addEventListener(
      "msfullscreenchange",
      function () {
        self.onFullScreen = document.fullscreenElement == null ? false : true
      },
      false
    )

    document.addEventListener(
      "mozfullscreenchange",
      function () {
        self.onFullScreen = document.fullscreenElement == null ? false : true
      },
      false
    )

    document.addEventListener(
      "webkitfullscreenchange",
      function () {
        self.onFullScreen = document.fullscreenElement == null ? false : true
      },
      false
    )
  },
  beforeDestory() {
    window.removeEventListener("resize")
  },
}
</script>

<style lang="less" scoped>
#container {
  position: absolute;
  left: 0;
  right: 0;
  top: 100px;
  bottom: 0;
  z-index: 1;
}

.nameoftransition-enter-active,
.nameoftransition-leave-active {
  transition: opacity 0.5s;
}

.nameoftransition-enter, .nameoftransition-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

//引入的字体样式
@font-face {
  font-family: "Unidtrsmled";
  src: url(../assets/font/UnidreamLED.ttf);
}

.quanp {
  width: 200px;
  height: 100px;
  float: right;
  position: absolute;
  top: 20px;
  right: -110px;
  z-index: 100;

  button {
    padding: 10px;
  }
}

.bigdata_container {
  * {
    box-sizing: content-box;
  }
}

/deep/ .el-carousel__container {
  height: 100% !important;

  .el-icon-arrow-left:before,
  .el-icon-arrow-right:before {
    color: #489aff;
    font-weight: bold;
    font-size: 22px;
  }
}

.bigdata_container {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: url("../assets/img/bg.png") no-repeat center center;
  background-size: 100% 100%;

  .header {
    margin: auto;
    width: 90%;
    height: 100px;
    background: url("../assets/img/top.png") no-repeat center center;
    background-size: 100%;
  }

  .main_left {
    margin-top: 2%;
    position: absolute;
    width: 23%;
    height: calc(100vh - 100px);
    margin-left: 1%;
    z-index: 2;

    .left {
      margin-top: 2%;
      width: 100%;
      padding-left: 1%;

      .headerBox {
        margin-left: 10px;
        line-height: 50px;
        height: 50px;
        color: #01c5e2;
      }

      .iconBox {
        height: calc(100% - 50px);
        display: flex;

        .box {
          color: #fff;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          display: flex;

          .img {
            img {
              margin: 0 10%;
              width: 80%;
            }
          }

          .txt {
            font-size: 15px;
            cursor: pointer;
            span {
              font-size: 30px;
              font-family: Unidtrsmled;
            }
          }
        }
      }
    }

    .left_top {
      background: url(../assets/img/a3.png);
      background-size: 100% 100%;
      height: 17vh;
    }

    .left_center {
      margin-top: 20px;
      background: url(../assets/img/left.png);
      background-size: 100% 100%;
      height: 31vh;

      .typeClick {
        margin-right: 10px;
        float: right;
        color: #fff;
        position: relative;
        z-index: 1000;

        .active {
          padding-bottom: 2px;
          border-bottom: 1px solid #038bff;
        }

        span {
          margin: 0 10px;
        }
      }

      .type {
        height: 24.5vh;
        width: 100%;
      }
    }

    .left_bottom {
      margin-top: 20px;
      background: url(../assets/img/left.png);
      background-size: 100% 100%;
      height: 31vh;

      .type {
        height: 23vh;
        width: 100%;
      }
    }
  }

  .main_right {
    margin-top: 2%;
    position: absolute;
    right: 0;
    width: 22.5%;
    margin-right: 1%;
    height: calc(100vh - 100px);
    z-index: 2;

    .right {
      margin-top: 2%;
      width: 100%;
      padding-left: 1%;

      .headerBox {
        margin-left: 10px;
        line-height: 50px;
        height: 50px;
        color: #01c5e2;
      }

      .iconBox {
        height: calc(100% - 50px);
        display: flex;

        .box {
          color: #fff;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          display: flex;

          .img {
            img {
              margin: 0 10%;
              width: 80%;
            }
          }

          .txt {
            font-size: 15px;

            span {
              font-size: 30px;
              font-family: Unidtrsmled;
            }
          }
        }
      }
    }

    .right_top {
      background: url(../assets/img/right.png);
      background-size: 100% 100%;

      .type {
        height: 23vh;
        width: 100%;
      }
    }

    .right_center {
      background: url(../assets/img/right.png);
      background-size: 100% 100%;

      .type {
        height: 23vh;
        width: 100%;
      }
    }

    .right_bottom {
      background: url(../assets/img/right.png);
      background-size: 100% 100%;
      height: 31vh;
      overflow: hidden;
      .type::-webkit-scrollbar {
        display: none;
      }
      .type {
        height: 28vh;
        width: 100%;
        overflow-y: scroll;
        .li {
          padding-left: 4px;
          font-size: 14px;
          display: flex;
          margin-top: 10px;
          flex-direction: row;
          color: #fff;
          line-height: 24px;
          height: 24px;

          .img {
            border-radius: 50%;
            width: 20px !important;
            height: 20px !important;
            background: #489aff;
            text-align: center;
            font-size: 8px;
          }

          .txt {
            margin-left: 10px;
            width: 20%;
            overflow: hidden;
            height: 18px;
            overflow: hidden; //超出的文本隐藏
            text-overflow: ellipsis; //溢出用省略号显示
            white-space: nowrap; //溢出不换行
          }

          .time {
            overflow: hidden; //超出的文本隐藏
            text-overflow: ellipsis; //溢出用省略号显示
            white-space: nowrap; //溢出不换行
          }
        }
      }

      .flex1 {
        display: flex;
        flex-direction: column;
      }
    }
  }
}

// 搜索
/deep/ .serach_wrapper {
  z-index: 2;
  position: absolute;
  left: 50%;
  top: 15vh;
  transform: translateX(-50%);

  .el-button {
    color: #0291c2;
    background: #041d4d;
    border: none;
  }

  .el-input__inner {
    color: #0291c2;
    background: #102132;
    border-color: #233b87;
  }
}

// 弹框步骤条样式
/deep/ .el-step__icon.is-text {
  border-radius: 5px;
}

/deep/ .is-finish .el-step__icon {
  background: #409eff;
}

/deep/ .el-step__icon {
  width: auto;
  padding: 15px 20px;
  color: #ffffff;
  cursor: pointer;
  border: none;
  background: #c0c4cc;
}

/deep/ .el-step {
  height: 40px;
  margin-bottom: 24px;
}

/deep/ .el-step.is-horizontal .el-step__line {
  top: 16px;
}

.avatar {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 200px;
  height: 200px;
  line-height: 200px;
  img {
    width: 200px;
    height: 200px;
    line-height: 200px;
    display: block;
  }
}
/deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  width: 200px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100%;
    height: 200px;
    line-height: 200px;
    text-align: center;
  }
}
// 回访内容
.return_visit_form {
  .formheader {
    display: flex;
    justify-content: space-between;
    padding: 24px 0 36px;
  }
}
.customerTop {
  img {
    width: 100%;
    height: 88px;
  }
  h1 {
    color: #6ebcff;
    position: absolute;
    text-align: center;
    font-weight: bolder;
    font-size: 35px;
    left: 0;
    top: 0;
    width: 100%;
    height: 78px;
    line-height: 78px;
    z-index: 3;
  }
  .titleFirst {
    min-width: 560px;
    position: absolute;
    width: 560px;
    // border-top: 78px solid #1e69b6;
    border-left: 40px solid transparent;
    border-right: 40px solid transparent;
    height: 0;
    left: 50%;
    top: 0;
    margin-left: -310px;
    z-index: 2;
  }
  .titleSecond {
    min-width: 620px;
    width: 620px;
    position: absolute;
    // border-top: 78px solid #103b71;
    border-left: 40px solid transparent;
    border-right: 40px solid transparent;
    height: 0;
    left: 50%;
    top: 0;
    margin-left: -340px;
  }
}
</style>
